import { StepConnector, withStyles } from '@material-ui/core';

export const StepItemConector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(34, 214, 21) 0%,rgb(126, 171, 80) 50%,rgb(87, 73, 87) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(34, 214, 21) 0%,rgb(126, 171, 80) 50%,rgb(34, 214, 21) 100%)',
    },
  },
  error: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(172, 2, 2) 0%,rgb(133, 40, 40) 50%,rgb(87, 73, 87) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);
